module.exports = __webpack_public_path__ + "static/media/venndiagram3.942a3dcb.png";